<template>
  <ul class="header-tools">
    <li>
      <a :href="!isTaiwanClient ? securityHost : securityHostOkki">
        <Security />
      </a>
    </li>
    <li>
      <a :href="!isTaiwanClient ? mallHost : mallHostOkki">
        <Shop class="tool" />
      </a>
    </li>
    <li>
      <Language
        class="tool"
        @switch="handleLanguage"
      />
    </li>
    <li class="divide">
      <Help
        class="tool"
        system-name="crm"
        :user-info="userInfo"
        :plan-version="planVersion"
      />
    </li>
    <li>
      <Profile
        class="tool"
        :user-info="userInfo"
        :operations="operations"
      />
    </li>
  </ul>
</template>
<script>
  import mainApi from '@api/main';

  import {mapState, mapActions, mapGetters} from 'vuex'
  import {
    Profile,
    Language,
    Shop,
    Help,
    Security
  } from '@libs/riven/src/index'
  import Host from '@config/host'

  export default {
    name: 'XmHeader',
    data () {
      return {
        securityHost: process.env.HOSTS.SECURITY,
        securityHostOkki: process.env.HOSTS.SECURITY_OKKI,
        mallHost: process.env.HOSTS.MALL,
        mallHostOkki: process.env.HOSTS.MALL_OKKI,
        planVersion: {},
        operations: Object.freeze({
          me: {
            handler() {
              window.location.href = Host.personal
            }
          },
          e: {
            handler() {
              window.location.href = Host.enterprise
            }
          },
          recommend: {
            disabled: true
          },
          log: {
            disabled: true
          },
          update: {
            disabled: true
          },
          setting: {
            disabled: true
          },
          logout: {
            handler() {
              window.location.href = Host.me + '/login?system_id=mall&return_url=' + encodeURIComponent(window.location.href)
            },
          },
        })
      }
    },
    created() {
      this.isClientActive && this.fetchPlanVersion()
    },
    computed: {
      ...mapState('main', {
        userInfo: state => state.userInfo.user,
        isClientActive: state => state.isClientActive,
      }),
      ...mapGetters("main", ["isTaiwanClient"]),
    },
    watch: {
      isClientActive (val) {
        if (val) {
          this.fetchPlanVersion()
        }
      }
    },
    methods: {
      ...mapActions('main', ['saveUserSetttingLanguage']),
      handleLanguage (value) {
        const formData = new FormData()
        formData.append('key', 'USER_LANGUAGE')
        formData.append('value', value)
        this.saveUserSetttingLanguage(formData).then(() => {
          window.location.reload()
        })
      },
      fetchPlanVersion() {
        mainApi.fetchPlanVersion().then(data => {
          this.planVersion = data
        })
      },
    },
    components: {
      Profile,
      Language,
      Shop,
      Help,
      Security
    }
  }
</script>
<style lang="scss">
  .header-tools{
    display: flex;
    padding-right: 20px;
    .mm-badge {
      line-height: 1.5;
    }
    .tool{
      margin-left: 38px;
    }
    .common-iconfont {
      color: #909090;
      font-size: 22px;
      cursor: pointer;
    }
    li.divide {
      position: relative;
      margin-right: 10px;
      &:after {
        content: "";
        width: 1px;
        height: 22px;
        position: absolute;
        top: 50%;
        right: -24px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        background: #d9d9d9;
      }
    }
  }
</style>

